module.exports = __webpack_public_path__ + "static/media/shuffle.b913d0a3.wav";